import { render, staticRenderFns } from "./ExamPaper.vue?vue&type=template&id=dfe7b238&scoped=true"
import script from "./ExamPaper.vue?vue&type=script&lang=js"
export * from "./ExamPaper.vue?vue&type=script&lang=js"
import style0 from "./ExamPaper.vue?vue&type=style&index=0&id=dfe7b238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe7b238",
  null
  
)

export default component.exports